module.exports = __webpack_public_path__ + "static/images/coupon-img.a53469b.png";